<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" sm="6" md="4" v-if="isNew">
        <v-autocomplete
          v-model="invoice.client"
          :items="clients.items"
          label="Client"
          persistent-hint
          item-text="name"
          return-object
          filled
          outlined
          hide-details
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" v-if="!isNew">
        <v-text-field
          :value="invoice.client.name"
          label="Client"
          outlined
          readonly
          filled
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="auto">
        <v-text-field
          v-model="invoice.invoiceNo"
          type="number"
          label="Invoice No"
          outlined
          filled
          hide-details
          style="width:120px;float:left"
          class="mr-3"
          v-if="!isNew"
        ></v-text-field>

        <v-text-field
          v-model="invoice.purchaseOrderNo"
          label="PO No"
          placeholder="Purchase Order No"
          outlined
          filled
          hide-details
          style="width:120px;float:left"
          class="mr-3"
          v-if="!isNew"
        ></v-text-field>

        <date
          v-model="invoice.date"
          :style="'width:120px;float:left'"
          label="Invoice Date"
          class="mr-3"
        ></date>
        <v-currency-field
          v-model="invoice.subtotal"
          style="min-width:100px;max-width:100px;float:left"
          label="Subtotal"
          currency="GBP"
          filled
          outlined
          hide-details
          class="mr-3"
        />
        <v-currency-field
          v-model="invoice.vat"
          style="min-width:100px;max-width:100px;float:left"
          label="VAT"
          currency="GBP"
          filled
          outlined
          hide-details
          class="mr-3"
        />
        <v-currency-field
          :value="total"
          readonly
          style="min-width:100px;max-width:100px;float:left"
          label="Total"
          currency="GBP"
          filled
          outlined
          hide-details
          class="mr-3"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment, { min } from "moment";
import date from "@/components/date";

export default {
  props: {
    invoice: Object
  },
  components: {
    date
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      account: state => state.account,
      clients: state => state.clients
    }),
    isNew() {
      return !this.invoice._id;
    },
    total() {
      return (this.invoice.subtotal + this.invoice.vat).toFixed(2);
    }
  },
  methods: {}
};
</script>

<style>
</style>